<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.7067 20.326C19.7412 21.0375 18.547 21.444 17.2639 21.444C14.037 21.444 11.4199 18.827 11.4199 15.6001C11.4199 12.3732 14.037 9.75618 17.2639 9.75618C18.6994 9.75618 20.0207 10.277 21.037 11.1409M7.62139 14.8506C7.62139 14.8506 9.7811 13.7707 13.2747 13.7707C16.7684 13.7707 18.9281 14.8506 18.9281 14.8506M7.62139 17.4295C7.62139 17.4295 9.7811 16.3496 13.2747 16.3496C16.7684 16.3496 18.9281 17.4295 18.9281 17.4295M29.5996 15.6001C29.5996 23.3321 23.3316 29.6001 15.5996 29.6001C7.86762 29.6001 1.59961 23.3321 1.59961 15.6001C1.59961 7.86811 7.86762 1.6001 15.5996 1.6001C23.3316 1.6001 29.5996 7.86811 29.5996 15.6001Z"
      stroke="#ED166E"
      stroke-width="2"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
